import type { RouteRecordRaw } from 'vue-router';
import type { MenuTreeAdapter, MenuItem } from './types';
import { getMenus } from '../../../apis/methods/menu';
import type { MenuBaseOn } from '../settings/types';

/**
 * 从前端配置获取菜单树
 */
export const getMenuTreeFromFrontend: MenuTreeAdapter = async (baseOn, routers, roleId) => {
  return getMenuTreeFromBackend(baseOn, routers, roleId);
};

const getMenusFromRouter = (baseOn: MenuBaseOn, routes: readonly RouteRecordRaw[] | undefined): MenuItem[] => {
  if (!routes || routes.length === 0) return [];
  return routes
    .map((route) => {
      const { meta = {} } = route;
      return {
        path: route.path,
        title: meta.title || '',
        icon: meta.icon,
        order: meta.order ?? 0,
        isLink: meta.isLink,
        children: getMenusFromRouter(baseOn, route.children),
        permission: meta.permission,
        hideInMenu: !!route.meta?.hideInMenu
      } as MenuItem;
    });
};

/**
 * 从路由生成菜单树
 * @param routes
 */
export const getMenuTreeFromRouter: MenuTreeAdapter = async (baseOn, routes, roleId) => {
  return getMenusFromRouter(baseOn, routes);
};

/**
 * 从后端获取菜单树
 */
export const getMenuTreeFromBackend: MenuTreeAdapter = async (baseOn, routers, roleId) => {
  const res = await getMenus(baseOn, routers, roleId);
  if (res?.success) {
    return res.obj;
  }
  return [];
};

/**
 * 从百源配置获取菜单树
 */
export const getMenuTreeFromBasp: MenuTreeAdapter = async (baseOn, routers, roleId) => {
  return getMenuTreeFromBackend(baseOn, routers, roleId);
  // const { success, obj } = await queryMenusTree();
  // if (success) {
  //   return baspMenusFormat(obj);
  // }
  // return [];
};

export const getMenuTreeAdapter = (baseOn: MenuBaseOn): MenuTreeAdapter | null => {
  switch (baseOn) {
    case 'frontend':
      // 前端配置，文件系统路由只支持前端配置菜单
      return getMenuTreeFromFrontend;
    case 'routes':
      // 根据路由生成
      return getMenuTreeFromRouter;
    case 'backend': // 后端配置
      return getMenuTreeFromBackend;
    case 'basp': // 百源配置
      return getMenuTreeFromBasp;
    default:
      return null;
  }
};
